var _path, _path2, _rect, _rect2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#E7EBEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0329 18L28.9671 18C29.9872 18 30.3878 16.6486 29.539 16.0706L21.1438 10.3538C20.4512 9.88208 19.5488 9.88208 18.8562 10.3538L10.461 16.0706C9.61224 16.6486 10.0128 18 11.0329 18Z",
    stroke: "#0F0F0F",
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    width: 5,
    height: 8,
    stroke: "#0F0F0F",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 18,
    width: 5,
    height: 8,
    stroke: "#0F0F0F",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.382 26C27.7607 26 28.107 26.214 28.2764 26.5528L29.2764 28.5528C29.6088 29.2177 29.1253 30 28.382 30L11.618 30C10.8747 30 10.3912 29.2177 10.7236 28.5528L11.7236 26.5528C11.893 26.214 12.2393 26 12.618 26L27.382 26Z",
    stroke: "#0F0F0F",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.8775881a8bc753cd779c16ad52dc3dd0.svg";
export { ForwardRef as ReactComponent };